import React from 'react';
import { Input } from 'antd';
const { TextArea } = Input;
export const TextInput = ({ disabled = false, value, placeholder, minLines = 1, maxLines = 1, setText, style, }) => {
    return (React.createElement(TextArea, { disabled: disabled, value: value, placeholder: placeholder, autoSize: { minRows: minLines, maxRows: maxLines }, onChange: (e) => setText(e.target.value), style: {
            borderRadius: 2,
            borderTopWidth: 0,
            borderBottomWidth: 1,
            borderRightWidth: 0,
            borderLeftWidth: 0,
            backgroundColor: 'transparent',
            ...style,
        } }));
};
